import React, {
  FunctionComponent as FC,
  useContext,
  useState,
  useEffect,
} from "react";

import EditableRichText from "@components/elements/EditableRichText";
import { FunnelContext } from "../FunnelContext";
import {
  isEditMode,
  ratingTitle,
  renderTitleRichTextContent,
} from "@utils/funnel";
import { useMutation } from "react-query";
import {
  IPageUpdateParams,
  updatePage,
} from "@components/funnel/hooks/usePageUpdate";
import { useAlert } from "react-alert";

import { $FunnelPageTitle } from "../LandingPageTitle/LandingPageTitle.sc";

const DirectFeedbackTitle: FC = () => {
  const { funnelData, updateFrontend } = useContext(FunnelContext);
  const [updatingTitle, setUpdatingTitle] = useState<boolean>(false);
  const alert = useAlert();
  const {
    site_attributes,
    page_attributes,
    content_modules_attributes,
    config_modules_attributes
  } = funnelData.backend;

  const generateTitleInHtml = (): string => {
    return renderTitleRichTextContent({
      template:
        content_modules_attributes
          .direct_feedback_title_html,
      value: ratingTitle(funnelData),
    });
  };

  const [titleInHtml, setTitleInHtml] = useState<string>(generateTitleInHtml());

  useEffect(() => {
    setTitleInHtml(generateTitleInHtml());
  }, [
    content_modules_attributes.direct_feedback_title_html,
    funnelData.funnelFlow.selectedRatingString,
  ]);

  const mutation = useMutation((params: IPageUpdateParams) =>
    updatePage(params)
  );

  const onTitleChange = (html: string) => {
    setUpdatingTitle(true);

    mutation.mutate(
      {
        site_uuid: site_attributes.uuid,
        page_uuid: page_attributes.uuid,
        funnel_data: {
          content_modules_attributes: {
            id: content_modules_attributes.id,
            direct_feedback_title_html: html
          }
        }
      },
      {
        onSuccess: (responseData) => {
          setUpdatingTitle(false);
          funnelData.backend = responseData;
          updateFrontend();
        },
        onError: (error) => {
          setUpdatingTitle(false);
          //@ts-ignore
          const errorMessage = error.response?.data?.errors ? error.response.data.errors.join(", ") : "Please try again later.";

          alert.error(
            <>
              <h3>Something went wrong.</h3>
              <p>{errorMessage}</p>
            </>
          );
        },
      }
    );
  };

  return (
    <$FunnelPageTitle
      className="direct-feedback-title"
      color={config_modules_attributes.text_color}
    >
      <EditableRichText
        fieldName="Headline"
        tooltip="This text reflects<br/>the user's rating"
        fullWidth={true}
        isEditable={isEditMode(funnelData)}
        text={titleInHtml}
        formatWholeText={true}
        onChange={onTitleChange}
        updating={updatingTitle}
      />
    </$FunnelPageTitle>
  );
};

export default DirectFeedbackTitle;
